import { useCallback } from 'react';
import { getClipDurationInSeconds } from '@goldcast/player-config/src/utils/clipUtils';
import { updateClipData } from '../clipUpdateDataUtils';
import { CLIP_UPDATE_TYPE } from '../clipUpdateDataUtils/constants';
import { remotionPlayerStateStore } from '../store/remotionPlayerState';
import { useRemotionPlayerSeek } from '@/App/remotion/MainPlayer/ClipPlayerV2WithNewTimeline/hooks/useRemotionPlayerSeek';

export function useRemoveVideoSegment(clipId: string, segmentId: string) {
  const { seekTo } = useRemotionPlayerSeek();

  return useCallback(() => {
    const updatedClip = updateClipData({
      clipId,
      actionType: CLIP_UPDATE_TYPE.REMOVE_SEGMENT_TRACK,
      id: segmentId
    });

    if (updatedClip) {
      const newDuration = getClipDurationInSeconds(updatedClip);
      const { currentTime } = remotionPlayerStateStore.getSnapshot();
      if (currentTime > newDuration) {
        seekTo(newDuration);
      }
    }
  }, [clipId, segmentId, seekTo]);
}
